import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { fileUrl } from "@/lib/api";
import { Image as ImageIcon } from "lucide-react";

export default function GalleryPage() {
  const { t } = useTranslation();
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/albums").then((r) => setAlbums(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gallery-page" className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
      <div className="text-xs uppercase tracking-[0.3em] text-bordeaux-accent mb-4">{t("gallery.eyebrow")}</div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 mb-12">
        {t("gallery.title")}
      </h1>

      {loading ? (
        <div className="text-slate-500 text-sm">{t("common.loading")}</div>
      ) : albums.length === 0 ? (
        <div className="border border-dashed border-slate-200 rounded-sm py-20 text-center text-slate-500">
          <ImageIcon className="mx-auto mb-3" size={24} />
          {t("gallery.empty")}
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {albums.map((a) => (
            <Link
              key={a.id}
              to={`/galerie/${a.id}`}
              data-testid={`album-card-${a.id}`}
              className="group block bg-white border border-slate-200 rounded-sm overflow-hidden hover:border-bordeaux transition-colors"
            >
              <div className="aspect-[4/3] bg-beige overflow-hidden">
                {a.cover_path ? (
                  <img
                    src={fileUrl(a.cover_path)}
                    alt={a.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <div className="w-full h-full grid place-items-center text-slate-400">
                    <ImageIcon size={28} />
                  </div>
                )}
              </div>
              <div className="p-6 flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-slate-900 group-hover:text-bordeaux transition-colors">
                    {a.title}
                  </h3>
                  {a.description && <p className="text-sm text-slate-600 mt-1 line-clamp-2">{a.description}</p>}
                </div>
                <span className="text-xs uppercase tracking-widest text-slate-500 ml-4 flex-shrink-0">
                  {t("gallery.imageCount", { count: a.image_count })}
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
